module.exports = __webpack_public_path__ + "bda01ef3c9ee10416080a83759635302.jpg";